<template>
  <main class="main main--messaging main--full-height">
    <div class="messaging group group--first-last group--wide messaging--sidebar">
      <ui-messaging-sidebar key="sidebar"/>
      <module-inbox v-if="stage === 'inbox' || stage === 'outbox'" />
      <module-view-message v-else-if="stage === `view`"/>
      <module-compose-message v-if="stage === `compose`" />
    </div>
  </main>
</template>

<script>
// Vuex
import { mapActions , mapGetters } from 'vuex';
// Modules
import ModuleInbox from 'components/Inbox';
import ModuleComposeMessage from 'components/ComposeMessage';
import ModuleViewMessage from 'components/ViewMessage';
import UiMessagingSidebar from 'components/MessagingSidebar';


export default {
  name: 'messages',

  // Components
  components: {
    ModuleInbox,
    ModuleViewMessage,
    ModuleComposeMessage,
    UiMessagingSidebar,
  },

  // Data
  data() {
    return {
      stage: this.$route.params.id,
    };
  },

  // Computed
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
  },

  // Methods
  methods: {
    ...mapActions('messaging', ['requestAllMessages']),
  },

  beforeRouteUpdate(to, from, next) {
    localStorage.setItem('messagesPreviousStage', from.params.id);
    next();
  },

  beforeRouteEnter(to, from, next) {
    if(to.params.id === 'compose') {
      next( { name: 'messages', params: { id: 'inbox' } } );
    }
    next();
  },

  created() {
    if(!this.isAuthenticated) {
      this.$router.push({ name: 'login' });
    }
  },

};
</script>



// WEBPACK FOOTER //
// Messages.vue?47ff99a4